import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M31.983 4.256s.038.088 0 .126-.076.05-.126.026c-1.469-.938-4.228-1.799-6.329-2.166-3.29-.62-6.037-.71-8.884-.672-6.987-.038-14.48 2.508-14.48 5.244 0 1.026.9 2.014 2.595 2.875.038 0 .05.05.05.076 0 .063-.05.089-.088.089h-.038C1.646 8.739-.025 7.295 0 5.8.05 2.66 7.316 0 15.872 0h.746c.418 0 .848.025 1.266.038l1.696.114c5.48.481 10.252 2.026 12.378 4.09"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10.137 12.259c.165-4.18 3.367-7.397 6.316-9.005.038-.026.101 0 .126.025.026.05.026.101 0 .14-1.974 2.152-3.19 5.255-3.303 8.472-.215 5.611 3.443 10.462 7.113 11.906.05 0 .076.076.063.126a.11.11 0 0 1-.101.076c-4.771-.81-10.391-6.383-10.188-11.753"
    }, null, -1)
  ]))]))
}
export default { render: render }